import { Nullable } from '@aibees/shared/definition';
import { capitalize } from '@aibees/shared/utils';

export function humanReadableSeniority(seniority?: Nullable<string>) {
  if (!seniority) return '';
  const lower = seniority.toLowerCase();
  if (lower === 'vp') return 'VP';
  if (lower === 'mid-level') return 'Mid-level';
  if (lower === 'c_suite') return 'C-suite';
  return lower
    .replace(/[-_]/g, ' ')
    .replace(/\b[a-z]/g, (c) => c.toUpperCase());
}

export function humanReadableJobFunction(func?: Nullable<string>) {
  return capitalize(func?.replaceAll('_', ' ') || '');
}
